<template>
  <div class="w-100 row">
    <div class="mc-readonly" v-for="(item, idx) in items" :key="idx">
      <b-row>
        <b-col md="5">
          <p class="__label">{{ item.label }}</p>
        </b-col>
        <b-col md="7"
          >:
          <b :class="`__value${item.bold ? '-bold' : ''}`">{{ item.value }}</b>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  props: ['items'],
}
</script>

<style lang="scss">
// Techdebt: refactor the hex color as new SCSS variables
.mc-readonly {
  .__label {
    // Secondary/Navy/Navy 40
    color: $mep-color-text;
  }

  // color: $secondary;
  .__value {
    // Secondary/Navy/Navy 60
    color: $mep-color-text-300;
  }
  .__value-bold {
    // Secondary/Navy/Navy 80
    color: $mep-color-text-400;
    font-weight: 600;
  }
}
</style>
